import {
  MobileUseDesktopModalComponent, type MobileUseDesktopModalProps,
} from '~/map/listing/mobileUseDesktopModal.component';
import { modalRenderer } from '~/modal/modalRendererRegistry';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MobileUseDesktop: MobileUseDesktopModalProps;
  }
}

modalRenderer.register('MobileUseDesktop', MobileUseDesktopModalComponent);
